<router-outlet> </router-outlet>

<!-- Modal de autenticación global -->
<app-auth-modal></app-auth-modal>
